module.exports = __webpack_public_path__ + "img/pic_register3.1766306608134.png";